// extracted by mini-css-extract-plugin
export default {"zero":"EncashmentsCount_zero__MWV3Z","placeHolderShimmer":"EncashmentsCount_placeHolderShimmer__6fRd6"};